import { createSelector } from "reselect";

const envInfoSelector = (state: { mainState: { env: any; }; }) =>
  state.mainState && state.mainState.env ? state.mainState.env : {};

export const getElasticSearchURLS = createSelector(
  [envInfoSelector],
  (env) => env.elasticsearch_urls
);

export const getFooterSoftwareInfos = createSelector([envInfoSelector], (env) => ({
  websiteAddress: env.website_address,
  appVersion: env.app_version,
}));
